import {REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
};
